import { ReactComponent as Icon } from "../icons/docs.svg";

const Docs = ({color, wth, curs, clickFunc}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, height: wth, marginTop: "5px", cursor: curs})} onClick={clickFunc}/>
    </div>
  );
};

export default Docs;